import BlogNewsletter from "../components/blog-newsletter";
import { NavSlider, NavSliderItem } from "../components/nav-slider";

export default {
	name: "Team",
	components: {
		BlogNewsletter,
		NavSlider,
		NavSliderItem,
	}
};
